import React, { useState } from "react";
import Card, { CardBody } from "../../../../../components/bootstrap/Card";
import useSortableData from "../../../../../hooks/useSortableData";
import PaginationButtons, {
  dataPagination,
} from "../../../../../components/PaginationButtons";
import useSelectTable from "../../../../../hooks/useSelectTable";
import Icon from "../../../../../components/icon/Icon";
import Checks from "../../../../../components/bootstrap/forms/Checks";

const StudentsTable = ({ onAdd, students }) => {
  // const [learninPaths, setLearningPaths] = useState(()=>learninPaths);

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(3);
  const { items, requestSort, getClassNamesFor } =
    useSortableData(students);
  const onCurrentPageData = dataPagination(items, currentPage, perPage);
  const { selectTable, SelectAllCheck } = useSelectTable(onCurrentPageData);

  return (
    <div >
      <Card>
        <CardBody>
          <table className="table table-modern">
            <thead>
              <tr>
                <th style={{ width: 50 }}>{SelectAllCheck}</th>
                <th
                  onClick={() => requestSort("name")}
                  className="cursor-pointer text-decoration-underline"
                >
                  Başlık{" "}
                  <Icon
                    size="lg"
                    className={getClassNamesFor("firstName")}
                    icon="FilterList"
                  />
                </th>
                <th
                  onClick={() => requestSort("lastName")}
                  className="cursor-pointer text-decoration-underline"
                >
                  email{" "}
                  <Icon
                    size="lg"
                    className={getClassNamesFor("lastName")}
                    icon="FilterList"
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              {students.map((item) => (
                <tr key={item.id}>
                  <td>
                    <Checks
                      id={item.id.toString()}
                      name="selectedList"
                      value={item.id}
                      onChange={selectTable.handleChange}
                      checked={selectTable.values.selectedList.includes(
                        item.id.toString()
                      )}
                    />
                  </td>
                  <td>{item.first_name}</td>
                  <td>{item.student_email}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </CardBody>
        <PaginationButtons
          data={items}
          label="items"
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          perPage={perPage}
          setPerPage={setPerPage}
        />
      </Card>
    </div>
  );
};

export default StudentsTable;
